(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as Z, useQuery as Qt, useLazyQuery as Zt, useMutation as Te, isApolloError as Xt } from "@apollo/client";
import { __extends as er } from "tslib";
import ft, { useState as A, useEffect as W, createContext as gt, useContext as pt, useCallback as xe } from "react";
import { FormField as ge, FieldWrapper as Q, Badge as Le, Icon as $e, FlexBox as k, Text as oe, List as nt, Banner as tr, Button as ae, Modal as rr, ModalHead as nr, ModalBody as or, ModalFoot as ar, Tooltip as ht, Spinner as mt, FieldSwitch as ir, InputSelectionList as sr, SelectionList as cr } from "@dixa/lib-shared-habla";
import { Link as lr } from "react-router-dom";
import { colors as K } from "@dixa/lib-shared-tokens";
import vt from "moment";
import { useInterval as ur } from "react-use";
import { HookFormText as dr } from "lib-shared-hook-form";
import { useController as fr } from "react-hook-form";
const un = Z`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, gr = Z`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, pr = Z`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, hr = Z`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`;
var We = "Invariant Violation", ot = Object.setPrototypeOf, mr = ot === void 0 ? function(t, r) {
  return t.__proto__ = r, t;
} : ot, vr = (
  /** @class */
  (function(t) {
    er(r, t);
    function r(a) {
      a === void 0 && (a = We);
      var o = t.call(this, typeof a == "number" ? We + ": " + a + " (see https://github.com/apollographql/invariant-packages)" : a) || this;
      return o.framesToPop = 1, o.name = We, mr(o, r.prototype), o;
    }
    return r;
  })(Error)
);
function q(t, r) {
  if (!t)
    throw new vr(r);
}
var yt = ["debug", "log", "warn", "error", "silent"], yr = yt.indexOf("log");
function we(t) {
  return function() {
    if (yt.indexOf(t) >= yr) {
      var r = console[t] || console.log;
      return r.apply(console, arguments);
    }
  };
}
(function(t) {
  t.debug = we("debug"), t.log = we("log"), t.warn = we("warn"), t.error = we("error");
})(q || (q = {}));
var Et = "3.14.0";
function ne(t) {
  try {
    return t();
  } catch {
  }
}
const at = ne(function() {
  return globalThis;
}) || ne(function() {
  return window;
}) || ne(function() {
  return self;
}) || ne(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
ne(function() {
  return ne.constructor("return this")();
});
var it = /* @__PURE__ */ new Map();
function Er(t) {
  var r = it.get(t) || 1;
  return it.set(t, r + 1), "".concat(t, ":").concat(r, ":").concat(Math.random().toString(36).slice(2));
}
function Cr(t, r) {
  var a = Er("stringifyForDisplay");
  return JSON.stringify(t, function(o, c) {
    return c === void 0 ? a : c;
  }, r).split(JSON.stringify(a)).join("<undefined>");
}
function _e(t) {
  return function(r) {
    for (var a = [], o = 1; o < arguments.length; o++)
      a[o - 1] = arguments[o];
    if (typeof r == "number") {
      var c = r;
      r = bt(c), r || (r = xt(c, a), a = []);
    }
    t.apply(void 0, [r].concat(a));
  };
}
Object.assign(function(r, a) {
  for (var o = [], c = 2; c < arguments.length; c++)
    o[c - 2] = arguments[c];
  r || q(r, bt(a, o) || xt(a, o));
}, {
  debug: _e(q.debug),
  log: _e(q.log),
  warn: _e(q.warn),
  error: _e(q.error)
});
var st = Symbol.for("ApolloErrorMessageHandler_" + Et);
function Ct(t) {
  if (typeof t == "string")
    return t;
  try {
    return Cr(t, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function bt(t, r) {
  if (r === void 0 && (r = []), !!t)
    return at[st] && at[st](t, r.map(Ct));
}
function xt(t, r) {
  if (r === void 0 && (r = []), !!t)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Et,
      message: t,
      args: r.map(Ct)
    })));
}
function Re(t) {
  return t.definitions.filter(function(r) {
    return r.kind === "OperationDefinition" && !!r.name;
  }).map(function(r) {
    return r.name.value;
  })[0] || null;
}
const dn = (t, r) => function(a, o) {
  return Qt(a, {
    ...o,
    context: {
      operationName: Re(a),
      ...o?.context,
      widgetId: t,
      widgetType: r
    }
  });
}, fn = (t, r) => function(a, o) {
  return Zt(a, {
    ...o,
    context: {
      operationName: Re(a),
      ...o?.context,
      widgetId: t,
      widgetType: r
    }
  });
}, gn = (t, r, a) => function(o, c) {
  return a.query({
    query: o,
    variables: c,
    context: {
      operationName: Re(o),
      widgetId: t,
      widgetType: r
    }
  });
}, pn = (t, r) => function(a, o) {
  return Te(a, {
    ...o,
    context: {
      operationName: Re(a),
      ...o?.context,
      widgetId: t,
      widgetType: r
    }
  });
};
var Oe = { exports: {} }, de = {};
var ct;
function br() {
  if (ct) return de;
  ct = 1;
  var t = ft, r = Symbol.for("react.element"), a = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, c = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function h(b, d, x) {
    var u, v = {}, w = null, _ = null;
    x !== void 0 && (w = "" + x), d.key !== void 0 && (w = "" + d.key), d.ref !== void 0 && (_ = d.ref);
    for (u in d) o.call(d, u) && !g.hasOwnProperty(u) && (v[u] = d[u]);
    if (b && b.defaultProps) for (u in d = b.defaultProps, d) v[u] === void 0 && (v[u] = d[u]);
    return { $$typeof: r, type: b, key: w, ref: _, props: v, _owner: c.current };
  }
  return de.Fragment = a, de.jsx = h, de.jsxs = h, de;
}
var fe = {};
var lt;
function xr() {
  return lt || (lt = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = ft, r = Symbol.for("react.element"), a = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), b = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), T = Symbol.iterator, R = "@@iterator";
    function N(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = T && e[T] || e[R];
      return typeof n == "function" ? n : null;
    }
    var f = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(e) {
      {
        for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), l = 1; l < n; l++)
          s[l - 1] = arguments[l];
        I("error", e, s);
      }
    }
    function I(e, n, s) {
      {
        var l = f.ReactDebugCurrentFrame, E = l.getStackAddendum();
        E !== "" && (n += "%s", s = s.concat([E]));
        var C = s.map(function(m) {
          return String(m);
        });
        C.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, C);
      }
    }
    var V = !1, J = !1, B = !1, Se = !1, ie = !1, pe;
    pe = Symbol.for("react.module.reference");
    function Ae(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === o || e === g || ie || e === c || e === x || e === u || Se || e === _ || V || J || B || typeof e == "object" && e !== null && (e.$$typeof === w || e.$$typeof === v || e.$$typeof === h || e.$$typeof === b || e.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === pe || e.getModuleId !== void 0));
    }
    function De(e, n, s) {
      var l = e.displayName;
      if (l)
        return l;
      var E = n.displayName || n.name || "";
      return E !== "" ? s + "(" + E + ")" : s;
    }
    function he(e) {
      return e.displayName || "Context";
    }
    function F(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case o:
          return "Fragment";
        case a:
          return "Portal";
        case g:
          return "Profiler";
        case c:
          return "StrictMode";
        case x:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case b:
            var n = e;
            return he(n) + ".Consumer";
          case h:
            var s = e;
            return he(s._context) + ".Provider";
          case d:
            return De(e, e.render, "ForwardRef");
          case v:
            var l = e.displayName || null;
            return l !== null ? l : F(e.type) || "Memo";
          case w: {
            var E = e, C = E._payload, m = E._init;
            try {
              return F(m(C));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, L = 0, me, ve, se, ce, X, ye, le;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function Y() {
      {
        if (L === 0) {
          me = console.log, ve = console.info, se = console.warn, ce = console.error, X = console.group, ye = console.groupCollapsed, le = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        L++;
      }
    }
    function $() {
      {
        if (L--, L === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, e, {
              value: me
            }),
            info: U({}, e, {
              value: ve
            }),
            warn: U({}, e, {
              value: se
            }),
            error: U({}, e, {
              value: ce
            }),
            group: U({}, e, {
              value: X
            }),
            groupCollapsed: U({}, e, {
              value: ye
            }),
            groupEnd: U({}, e, {
              value: le
            })
          });
        }
        L < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = f.ReactCurrentDispatcher, H;
    function ee(e, n, s) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (E) {
            var l = E.stack.trim().match(/\n( *(at )?)/);
            H = l && l[1] || "";
          }
        return `
` + H + e;
      }
    }
    var Ne = !1, Ee;
    {
      var Tt = typeof WeakMap == "function" ? WeakMap : Map;
      Ee = new Tt();
    }
    function Ue(e, n) {
      if (!e || Ne)
        return "";
      {
        var s = Ee.get(e);
        if (s !== void 0)
          return s;
      }
      var l;
      Ne = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var C;
      C = G.current, G.current = null, Y();
      try {
        if (n) {
          var m = function() {
            throw Error();
          };
          if (Object.defineProperty(m.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(m, []);
            } catch (j) {
              l = j;
            }
            Reflect.construct(e, [], m);
          } else {
            try {
              m.call();
            } catch (j) {
              l = j;
            }
            e.call(m.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (j) {
            l = j;
          }
          e();
        }
      } catch (j) {
        if (j && l && typeof j.stack == "string") {
          for (var p = j.stack.split(`
`), P = l.stack.split(`
`), O = p.length - 1, S = P.length - 1; O >= 1 && S >= 0 && p[O] !== P[S]; )
            S--;
          for (; O >= 1 && S >= 0; O--, S--)
            if (p[O] !== P[S]) {
              if (O !== 1 || S !== 1)
                do
                  if (O--, S--, S < 0 || p[O] !== P[S]) {
                    var M = `
` + p[O].replace(" at new ", " at ");
                    return e.displayName && M.includes("<anonymous>") && (M = M.replace("<anonymous>", e.displayName)), typeof e == "function" && Ee.set(e, M), M;
                  }
                while (O >= 1 && S >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, G.current = C, $(), Error.prepareStackTrace = E;
      }
      var re = e ? e.displayName || e.name : "", z = re ? ee(re) : "";
      return typeof e == "function" && Ee.set(e, z), z;
    }
    function Rt(e, n, s) {
      return Ue(e, !1);
    }
    function St(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function Ce(e, n, s) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Ue(e, St(e));
      if (typeof e == "string")
        return ee(e);
      switch (e) {
        case x:
          return ee("Suspense");
        case u:
          return ee("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return Rt(e.render);
          case v:
            return Ce(e.type, n, s);
          case w: {
            var l = e, E = l._payload, C = l._init;
            try {
              return Ce(C(E), n, s);
            } catch {
            }
          }
        }
      return "";
    }
    var ue = Object.prototype.hasOwnProperty, Ge = {}, Ve = f.ReactDebugCurrentFrame;
    function be(e) {
      if (e) {
        var n = e._owner, s = Ce(e.type, e._source, n ? n.type : null);
        Ve.setExtraStackFrame(s);
      } else
        Ve.setExtraStackFrame(null);
    }
    function At(e, n, s, l, E) {
      {
        var C = Function.call.bind(ue);
        for (var m in e)
          if (C(e, m)) {
            var p = void 0;
            try {
              if (typeof e[m] != "function") {
                var P = Error((l || "React class") + ": " + s + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw P.name = "Invariant Violation", P;
              }
              p = e[m](n, m, l, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (O) {
              p = O;
            }
            p && !(p instanceof Error) && (be(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", s, m, typeof p), be(null)), p instanceof Error && !(p.message in Ge) && (Ge[p.message] = !0, be(E), y("Failed %s type: %s", s, p.message), be(null));
          }
      }
    }
    var Dt = Array.isArray;
    function Ie(e) {
      return Dt(e);
    }
    function Nt(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, s = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return s;
      }
    }
    function It(e) {
      try {
        return Ye(e), !1;
      } catch {
        return !0;
      }
    }
    function Ye(e) {
      return "" + e;
    }
    function He(e) {
      if (It(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Nt(e)), Ye(e);
    }
    var Ke = f.ReactCurrentOwner, Pt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Je, ze;
    function jt(e) {
      if (ue.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Mt(e) {
      if (ue.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function kt(e, n) {
      typeof e.ref == "string" && Ke.current;
    }
    function Wt(e, n) {
      {
        var s = function() {
          Je || (Je = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function Ft(e, n) {
      {
        var s = function() {
          ze || (ze = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var Lt = function(e, n, s, l, E, C, m) {
      var p = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: s,
        props: m,
        // Record the component responsible for creating this element.
        _owner: C
      };
      return p._store = {}, Object.defineProperty(p._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(p, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.defineProperty(p, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(p.props), Object.freeze(p)), p;
    };
    function $t(e, n, s, l, E) {
      {
        var C, m = {}, p = null, P = null;
        s !== void 0 && (He(s), p = "" + s), Mt(n) && (He(n.key), p = "" + n.key), jt(n) && (P = n.ref, kt(n, E));
        for (C in n)
          ue.call(n, C) && !Pt.hasOwnProperty(C) && (m[C] = n[C]);
        if (e && e.defaultProps) {
          var O = e.defaultProps;
          for (C in O)
            m[C] === void 0 && (m[C] = O[C]);
        }
        if (p || P) {
          var S = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          p && Wt(m, S), P && Ft(m, S);
        }
        return Lt(e, p, P, E, l, Ke.current, m);
      }
    }
    var Pe = f.ReactCurrentOwner, qe = f.ReactDebugCurrentFrame;
    function te(e) {
      if (e) {
        var n = e._owner, s = Ce(e.type, e._source, n ? n.type : null);
        qe.setExtraStackFrame(s);
      } else
        qe.setExtraStackFrame(null);
    }
    var je;
    je = !1;
    function Me(e) {
      return typeof e == "object" && e !== null && e.$$typeof === r;
    }
    function Qe() {
      {
        if (Pe.current) {
          var e = F(Pe.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Bt(e) {
      return "";
    }
    var Ze = {};
    function Ut(e) {
      {
        var n = Qe();
        if (!n) {
          var s = typeof e == "string" ? e : e.displayName || e.name;
          s && (n = `

Check the top-level render call using <` + s + ">.");
        }
        return n;
      }
    }
    function Xe(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var s = Ut(n);
        if (Ze[s])
          return;
        Ze[s] = !0;
        var l = "";
        e && e._owner && e._owner !== Pe.current && (l = " It was passed a child from " + F(e._owner.type) + "."), te(e), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, l), te(null);
      }
    }
    function et(e, n) {
      {
        if (typeof e != "object")
          return;
        if (Ie(e))
          for (var s = 0; s < e.length; s++) {
            var l = e[s];
            Me(l) && Xe(l, n);
          }
        else if (Me(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var E = N(e);
          if (typeof E == "function" && E !== e.entries)
            for (var C = E.call(e), m; !(m = C.next()).done; )
              Me(m.value) && Xe(m.value, n);
        }
      }
    }
    function Gt(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var s;
        if (typeof n == "function")
          s = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === v))
          s = n.propTypes;
        else
          return;
        if (s) {
          var l = F(n);
          At(s, e.props, "prop", l, e);
        } else if (n.PropTypes !== void 0 && !je) {
          je = !0;
          var E = F(n);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vt(e) {
      {
        for (var n = Object.keys(e.props), s = 0; s < n.length; s++) {
          var l = n[s];
          if (l !== "children" && l !== "key") {
            te(e), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", l), te(null);
            break;
          }
        }
        e.ref !== null && (te(e), y("Invalid attribute `ref` supplied to `React.Fragment`."), te(null));
      }
    }
    var tt = {};
    function rt(e, n, s, l, E, C) {
      {
        var m = Ae(e);
        if (!m) {
          var p = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (p += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var P = Bt();
          P ? p += P : p += Qe();
          var O;
          e === null ? O = "null" : Ie(e) ? O = "array" : e !== void 0 && e.$$typeof === r ? (O = "<" + (F(e.type) || "Unknown") + " />", p = " Did you accidentally export a JSX literal instead of a component?") : O = typeof e, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", O, p);
        }
        var S = $t(e, n, s, E, C);
        if (S == null)
          return S;
        if (m) {
          var M = n.children;
          if (M !== void 0)
            if (l)
              if (Ie(M)) {
                for (var re = 0; re < M.length; re++)
                  et(M[re], e);
                Object.freeze && Object.freeze(M);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              et(M, e);
        }
        if (ue.call(n, "key")) {
          var z = F(e), j = Object.keys(n).filter(function(qt) {
            return qt !== "key";
          }), ke = j.length > 0 ? "{key: someKey, " + j.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!tt[z + ke]) {
            var zt = j.length > 0 ? "{" + j.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ke, z, zt, z), tt[z + ke] = !0;
          }
        }
        return e === o ? Vt(S) : Gt(S), S;
      }
    }
    function Yt(e, n, s) {
      return rt(e, n, s, !0);
    }
    function Ht(e, n, s) {
      return rt(e, n, s, !1);
    }
    var Kt = Ht, Jt = Yt;
    fe.Fragment = o, fe.jsx = Kt, fe.jsxs = Jt;
  })()), fe;
}
var ut;
function wr() {
  return ut || (ut = 1, process.env.NODE_ENV === "production" ? Oe.exports = br() : Oe.exports = xr()), Oe.exports;
}
var i = wr();
const hn = ({
  getValueByKey: t
}) => {
  const r = t("dixaApiTokenId")?.value, a = t("dixaApiTokenName")?.value;
  return /* @__PURE__ */ i.jsx(ge, { children: /* @__PURE__ */ i.jsx(Q, { label: "Dixa API-Token", children: !a || !r ? /* @__PURE__ */ i.jsx(i.Fragment, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ i.jsx(Le, { variant: "secondary", size: "small", children: a }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ i.jsx(lr, { to: `/settings/integrations/api-tokens/${r}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, _r = ({
  error: t
}) => t.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", mn = ({
  errors: t
}) => t.some((r) => _r({ error: r })), Or = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", vn = ({
  errors: t
}) => t.some((r) => Or({ error: r })), Tr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", yn = ({
  errors: t
}) => t.some((r) => Tr({ error: r })), Rr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", En = ({
  errors: t
}) => t.some((r) => Rr({ error: r })), Sr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", Cn = ({
  errors: t
}) => t.some((r) => Sr({ error: r })), Ar = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", bn = ({
  errors: t
}) => t.some((r) => Ar({ error: r })), Dr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", xn = ({
  errors: t
}) => t.some((r) => Dr({ error: r })), Nr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", wn = ({
  errors: t
}) => t.some((r) => Nr({ error: r })), Ir = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", _n = ({
  errors: t
}) => t.some((r) => Ir({ error: r })), Pr = ({
  error: t
}) => t.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", jr = ({
  errors: t
}) => t.some((r) => Pr({ error: r })), Mr = (t) => {
  const { delay: r = 2e3 } = t || {}, [a, o] = A(!1);
  return W(() => {
    const g = a ? window.setTimeout(() => o(!1), r) : void 0;
    return () => window.clearTimeout(g);
  }, [r, a]), { isCopied: a, copy: (g) => {
    navigator.clipboard.writeText(g), o(!0);
  } };
}, kr = "_errorWrapper_171rr_1", Wr = "_copyIcon_171rr_5", Fe = {
  errorWrapper: kr,
  copyIcon: Wr
}, Fr = ({
  error: t,
  retry: r,
  isMisconfigured: a = !1
}) => {
  const c = t && Xt(t) && t?.graphQLErrors?.length > 0, { isCopied: g, copy: h } = Mr(), b = /* @__PURE__ */ i.jsx(
    $e,
    {
      color: K.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (a || c && jr({
    errors: t.graphQLErrors
  }))
    return /* @__PURE__ */ i.jsxs(k, { margin: "0 0 100", padding: "200", className: Fe.errorWrapper, children: [
      /* @__PURE__ */ i.jsx(k, { margin: "0 300 0 0", alignItems: "center", children: b }),
      /* @__PURE__ */ i.jsx(oe.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!c)
    return /* @__PURE__ */ i.jsx(k, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ i.jsx(
      nt.Item,
      {
        contentLeft: b,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const d = t?.graphQLErrors || [];
  return /* @__PURE__ */ i.jsxs(
    k,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Fe.errorWrapper,
      children: [
        d.map((x, u) => {
          const v = x?.extensions?.integration, w = v?.message || t?.message || "No error message available", _ = v?.responseBody && JSON.parse(v?.responseBody), T = _?.errorMessages || [], R = _?.warningMessages || [], N = [...T, ...R].join(" ");
          return /* @__PURE__ */ i.jsx(
            nt.Item,
            {
              title: w,
              titleSecondary: N,
              contentLeft: b
            },
            u
          );
        }),
        /* @__PURE__ */ i.jsxs(k, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ i.jsx(
            tr,
            {
              variant: "info",
              description: /* @__PURE__ */ i.jsx(oe.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ i.jsxs(k, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            r && /* @__PURE__ */ i.jsx(ae, { variant: "secondary", icon: "sync", onClick: () => r(), children: "Retry" }),
            /* @__PURE__ */ i.jsx(
              ae,
              {
                variant: "secondary",
                icon: g ? "done" : "copy",
                onClick: () => h(JSON.stringify(d, null, 2)),
                className: Fe.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, Lr = ({
  headline: t,
  text: r,
  children: a,
  onConfirm: o,
  onCancel: c,
  confirmLabel: g,
  cancelLabel: h = "Cancel",
  confirmVariant: b = "primary",
  cancelVariant: d = "secondary",
  isOpen: x,
  setIsOpen: u,
  showOnClose: v = !1
}) => /* @__PURE__ */ i.jsxs(
  rr,
  {
    isOpen: x,
    onClose: () => {
      c && c(), u(!1);
    },
    children: [
      /* @__PURE__ */ i.jsx(
        nr,
        {
          title: t,
          onClose: v ? c : void 0
        }
      ),
      /* @__PURE__ */ i.jsxs(or, { children: [
        r && /* @__PURE__ */ i.jsx("div", { style: { width: "600px" }, children: r }),
        a
      ] }),
      /* @__PURE__ */ i.jsx(
        ar,
        {
          confirmOnClick: o ? () => {
            o(), u(!1);
          } : void 0,
          cancelOnClick: () => {
            c && c(), u(!1);
          },
          confirmName: g,
          cancelName: h,
          confirmProps: { variant: b },
          cancelProps: { variant: d }
        }
      )
    ]
  }
);
function On(t, r = !0) {
  try {
    return JSON.parse(JSON.stringify(t));
  } catch {
    return r && console.error(`Could not make a copy of ${JSON.stringify(t)}`), {};
  }
}
const Tn = (t) => `${t.charAt(0).toUpperCase()}${t.slice(1).toLowerCase()}`, wt = "DD MMM YYYY @ HH:mm";
function Rn(t) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      t.toUpperCase()
    ) ?? t;
  } catch {
    return t;
  }
}
const Sn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], An = (t) => {
  if (!t?.trim())
    return "Please add a valid subdomain";
  const a = ["https://", "http://"].find(
    (g) => t.startsWith(g)
  ), o = a ? `Please remove the protocol \`${a}\` from the hostname` : "", c = t.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && c)
    return `Please remove the protocol \`${a}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (c)
    return c;
};
function $r(t) {
  const r = t.split(".")[1];
  if (!r)
    throw Error("Invalid token");
  const a = r.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(a).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
function Br(t) {
  const { user_id: r, iss: a } = $r(t);
  return {
    "x-integration-user-id": r,
    "x-integration-organization-id": a
  };
}
function Ur(t) {
  return t.startsWith("http://localhost");
}
const Gr = gt(null);
function Vr() {
  const t = pt(Gr);
  if (t === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return t;
}
function Dn() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
function Be() {
  return { track: (r, a) => window._partner.events.emit(r, a) };
}
const Yr = (t) => {
  switch (t) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: K.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: K.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: K.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: K.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: K.neutral[500],
        tooltip: "Not connected"
      };
  }
}, Nn = ({
  configuration: t,
  integrationId: r,
  integrationType: a,
  label: o
}) => {
  const [c, g] = A("CONNECTING"), [h, b] = A(""), [d, x] = A(null), { track: u } = Be(), { icon: v, color: w, tooltip: _ } = Yr(c), T = 3, R = 15, N = 2e3, [f, y] = A({}), [I, V] = A(0), [J, B] = A(N), [Se, ie] = A(!1), [pe, Ae] = A(T), {
    isInboundOAuth: De,
    setIsInboundOAuth: he,
    hasTriggeredAuthorization: F,
    setHasTriggeredAuthorization: U
  } = Vr(), { baseUrl: L } = t, me = `${L}/auth/connect/${a.toLowerCase()}/${r}`, ve = `${L}/auth/status/${a.toLowerCase()}/${r}`, se = c === "CONNECTING", ce = (D) => Object.keys(D).length === 0, X = () => {
    ie(!1), V(0);
  };
  W(() => {
    const D = localStorage.getItem("authData");
    if (D) {
      const $ = JSON.parse(D ?? "{}").access_token;
      y({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${$}`,
          ...Ur(L) && Br($)
        }
      });
    }
  }, [L]), W(() => {
    ce(f) || ie(!0);
  }, [f]);
  const ye = () => {
    Ae(R), fetch(ve, { ...f }).then((D) => D.json()).then(({ data: D }) => {
      const { status: Y, createdAt: $, createdByName: G } = D;
      if (Y === "CONNECTING" && g("CONNECTING"), Y === "CONNECTED") {
        if (u("settings:view:oauth:succeeded", {
          widgetId: r,
          widgetType: a
        }), g("CONNECTED"), $ && G) {
          const H = new Date($);
          isNaN(H.getTime()) || x(H), b(G);
        }
        X();
      }
      Y === "NOT_CONNECTED" && (g("NOT_CONNECTED"), X());
    }).catch((D) => {
      console.warn(
        `Fetching OAuth status failed for ${a} ${r}`,
        D
      ), g("CONNECTION_FAILED");
    });
  };
  ur(
    () => {
      I >= pe ? (g("CONNECTION_TIMEOUT"), X()) : (ye(), V(I + 1));
    },
    Se ? J : null
  );
  const le = () => {
    u("settings:view:oauth:started", {
      widgetId: r,
      widgetType: a
    }), fetch(me, { ...f }).then((D) => D.json()).then(({ data: D }) => {
      const { url: Y } = D, $ = 620, G = 800, H = window.innerWidth / 2 - $ / 2, ee = window.innerHeight / 2 - G / 2;
      g("CONNECTING"), ie(!0), window.open(
        Y,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${$},
						height=${G},
						left=${H},
						top=${ee}`
      );
    }).catch((D) => {
      console.warn(
        `Fetching OAuth connection failed for ${a} ${r}`,
        D
      ), g("CONNECTION_FAILED");
    });
  };
  return W(() => {
    De && !F && !ce(f) && (U(!0), he(!1), le());
  }, [f]), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(ge, { span: 3, children: /* @__PURE__ */ i.jsx(
      Q,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ i.jsxs(k, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ i.jsx(
            ae,
            {
              icon: "key",
              variant: "secondary",
              onClick: le,
              disabled: se,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ i.jsx(ht, { content: _, children: se ? /* @__PURE__ */ i.jsx(mt, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ i.jsxs(k, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ i.jsx(
              $e,
              {
                "data-testid": "oauth-button-status-icon",
                name: v,
                color: w
              }
            ),
            c === "CONNECTED" && h && d && /* @__PURE__ */ i.jsxs(oe.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              h,
              " at",
              " ",
              vt(d).format(wt)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ i.jsx(ge, { span: 3 })
  ] });
}, _t = gt(null), In = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _t.Provider
);
function Ot() {
  const t = pt(_t);
  if (t === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return t;
}
const Hr = "_settingsWrapper_eleyu_1", Kr = {
  settingsWrapper: Hr
}, Jr = Z`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, dt = [], Pn = ({
  settings: t,
  getValueByKey: r,
  handleChangeSelect: a
}) => {
  const o = "subscriptionListId", g = t?.find(
    (f) => f.key === o
  )?.label ?? "Activate re-/subscription list selection", h = r(o)?.value, { useQuery: b } = Ot(), [d, x] = A(dt), [u, v] = A(!!h), [w, _] = A(h), {
    data: T,
    error: R,
    loading: N
  } = b(Jr, {
    skip: !u,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return W(() => {
    h && (_(h), v(!0));
  }, [h]), W(() => {
    const f = T?.Klaviyo?.get_lists;
    if (u && f && !N && !R) {
      const y = f?.data?.map(
        (I) => ({
          value: I?.id,
          label: I?.attributes?.name
        })
      ) || dt;
      x(y);
    }
  }, [u, T, N, R]), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(ge, { span: 3, children: /* @__PURE__ */ i.jsxs(
      k,
      {
        gap: "300",
        flexDirection: "column",
        className: Kr.settingsWrapper,
        children: [
          /* @__PURE__ */ i.jsx(Q, { label: g, children: /* @__PURE__ */ i.jsx(
            ir,
            {
              input: {
                name: `${o}-switch`,
                value: "switchValueFromComponent",
                checked: u,
                onChange: () => {
                  const f = !u;
                  f || a(o, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), v(f);
                }
              }
            }
          ) }),
          u && R && !N && /* @__PURE__ */ i.jsx(Q, { children: /* @__PURE__ */ i.jsx(Fr, { error: R }) }),
          u && !R && N && /* @__PURE__ */ i.jsx(Q, { children: /* @__PURE__ */ i.jsx(k, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ i.jsx(mt, {}) }) }),
          u && !R && !N && d && /* @__PURE__ */ i.jsx(Q, { label: "Available lists to subscribe to", children: /* @__PURE__ */ i.jsx(
            sr,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (f) => {
                a(o, f), _(f?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (f) => f ? /* @__PURE__ */ i.jsx(oe.Paragraph, { children: f.label }) : null,
              value: w ? [
                {
                  label: (d || []).find(
                    (f) => f.value === w
                  )?.label,
                  value: w
                }
              ] : [],
              equalityFn: (f, y) => f.value === y.value,
              children: d.map((f) => /* @__PURE__ */ i.jsx(cr.Item, { value: f, children: f.label }, f.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ i.jsx(ge, { span: 3 })
  ] });
}, jn = (t) => {
  if (t == null)
    return null;
  if (typeof t == "boolean" || t === "true" || t === "false") {
    const o = t === "true" || t === !0;
    return /* @__PURE__ */ i.jsx(
      $e,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? K.green[500] : K.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof t == "number" || /^\d*\.?\d+$/.test(t))
    return /* @__PURE__ */ i.jsx(Le, { variant: "success", size: "small", children: t });
  if (t.startsWith("days_ago: ")) {
    const o = t.replace("days_ago: ", ""), c = o.startsWith("-"), g = o === "0", h = c ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ i.jsx(oe.Paragraph, { variant: "5", color: "secondary", children: g ? "today" : h });
  }
  const a = vt(t);
  return a.isValid() ? /* @__PURE__ */ i.jsx(oe.Paragraph, { variant: "5", color: "secondary", children: a.format(wt) }) : /* @__PURE__ */ i.jsx(Le, { variant: "info", size: "small", children: t });
}, Mn = (t) => {
  const {
    isCreationMode: r = !1,
    componentProps: a,
    name: o,
    control: c,
    rules: g,
    defaultValue: h,
    shouldUnregister: b,
    label: d,
    helpIcon: x
  } = t, [u, v] = A(r), { field: w } = fr({
    name: o,
    control: c,
    rules: g,
    defaultValue: h,
    shouldUnregister: b
  }), _ = typeof d == "string" ? d : "";
  if (!u)
    return /* @__PURE__ */ i.jsx(Q, { label: d, helpIcon: x, children: /* @__PURE__ */ i.jsxs(
      ae,
      {
        "data-testid": `secret-field-button-${o}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => v(!0),
        children: [
          "Update ",
          _
        ]
      }
    ) });
  const R = {
    ...a,
    prefix: r ? a?.prefix : {
      type: "button",
      button: { icon: "close", onClick: () => {
        w.onChange(""), v(!1);
      } }
    }
  };
  return /* @__PURE__ */ i.jsx(dr, { ...t, componentProps: R });
}, zr = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, kn = ({
  integrationType: t,
  integrationId: r,
  widgetName: a,
  isCreationMode: o,
  isSubmitting: c,
  automationCouplingState: g,
  onConfirmDelete: h,
  labels: b,
  deleteConfirmationBody: d,
  confirmDeleteVariant: x = "primary"
}) => {
  const { track: u } = Be(), [v, w] = A(!1), _ = { ...zr, ...b }, T = !g || !g.isCoupled, R = () => {
    r && u("settings:view:delete:requested", {
      widgetId: r,
      widgetType: t
    }), w(!0);
  }, N = () => {
    r && u("settings:view:delete:canceled", {
      widgetId: r,
      widgetType: t
    });
  };
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(k, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ i.jsx(ae, { type: "submit", isLoading: c, disabled: c, children: _.submit }),
      !o && /* @__PURE__ */ i.jsx(
        ht,
        {
          content: "The widget is used in automations",
          disabled: T,
          children: /* @__PURE__ */ i.jsx(
            ae,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: R,
              disabled: !T,
              isLoading: g?.isLoading,
              children: _.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ i.jsx(
      Lr,
      {
        isOpen: v,
        setIsOpen: w,
        confirmVariant: x,
        confirmLabel: _.confirmDelete,
        cancelLabel: _.cancelDelete,
        onCancel: N,
        onConfirm: h,
        children: /* @__PURE__ */ i.jsx(k, { children: d ?? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          "Are you sure you want to delete the ",
          t,
          ' integration "',
          a,
          '"?'
        ] }) })
      }
    )
  ] });
}, qr = Z`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Qr = Z`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Wn(t) {
  const { useQuery: r, useMutation: a } = Ot(), [o, c] = A(), [g, h] = A(), [b, d] = A(!1), {
    loading: x,
    data: u,
    error: v
  } = r(
    qr,
    {
      skip: !t,
      variables: {
        conversationId: t?.toString()
      }
    }
  ), [w, { loading: _, error: T }] = a(
    Qr
  ), R = async (N, f) => await w({
    variables: {
      conversationId: (f ?? t)?.toString(),
      data: N
    }
  }).then(
    ({ data: I }) => c(I?.Storage?.storeWidgetData?.data ?? {})
  );
  return W(() => {
    !x && u && c(u?.Storage?.widgetData ?? {});
  }, [u, x]), W(() => v && h(v), [v]), W(() => d(x), [x]), W(() => T && h(T), [T]), W(() => d(_), [_]), {
    data: o,
    loading: b,
    store: R,
    error: g
  };
}
const Zr = "The configuration of the integration is not correct. Please check the settings.", Fn = ({
  integrationId: t,
  integrationType: r,
  handleRedirect: a,
  showNotification: o
}) => {
  const { track: c } = Be(), [g, h] = A(!1), [b, d] = A(), [x, u] = A(null), v = xe(
    (y) => (I) => {
      d(I), h(!1), o({
        title: "Something went wrong",
        text: `The ${y} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [w] = Te(pr, {
    onError: v("creation")
  }), [_] = Te(gr, {
    onError: v("update")
  }), [T] = Te(hr, {
    onError: v("deletion")
  }), R = xe(
    async ({ name: y, enabled: I, settings: V }) => {
      c("settings:create:submitted", { widgetType: r }), h(!0), d(void 0);
      const { data: J } = await w({
        variables: { type: r, name: y, enabled: I, settings: V }
      });
      h(!1);
      const B = J?.Management?.createWidgetConfiguration;
      if (!B) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), a(B.id);
    },
    [w, a, r, o, c]
  ), N = xe(
    async ({ name: y, enabled: I, settings: V }) => {
      if (!t)
        return;
      c("settings:view:change:submitted", {
        widgetId: t,
        widgetType: r
      }), h(!0), d(void 0);
      const { data: J } = await _({
        variables: { id: t, name: y, enabled: I, settings: V }
      });
      h(!1);
      const B = J?.Management?.updateWidgetConfiguration;
      if (!B) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      B.misconfigured ? u(
        B.misconfigurationCause ?? Zr
      ) : u(null), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [t, r, o, c, _]
  ), f = xe(async () => {
    if (!t)
      return;
    c("settings:view:delete:confirmed", {
      widgetId: t,
      widgetType: r
    }), h(!0), d(void 0);
    const { data: y } = await T({
      variables: { id: t }
    });
    h(!1), y?.Management?.deleteWidgetConfiguration && (a(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    T,
    a,
    t,
    r,
    o,
    c
  ]);
  return {
    create: R,
    update: N,
    remove: f,
    isLoading: g,
    error: b,
    misconfigurationCause: x,
    setMisconfigurationCause: u
  };
};
export {
  Fr as DisplayErrors,
  hn as DixaApiTokenSettings,
  Gr as InboundOAuthContext,
  Lr as IntegrationModal,
  Pn as KlaviyoSubscribeSetting,
  Nn as OAuthSettings,
  Mn as PartnerHookFormSecretText,
  In as WidgetContextProvider,
  kn as WidgetSettingsFormFooter,
  Tn as capitalizeFirstCharacter,
  Sn as countryCodes,
  Dn as createMockInboundOAuthContextOptions,
  pr as createWidgetConfigurationMutation,
  On as deepClone,
  wt as defaultDateFormat,
  hr as deleteWidgetConfigurationMutation,
  jn as displayAttributeValue,
  Yr as getConnectionStatusValues,
  Rn as getCountryNameFromCountryCode,
  Jr as getListsQuery,
  Br as getPartnerDevApiHeaders,
  un as getWidgetConfigurationByIdQuery,
  mn as hasDixaHeaderCheckError,
  vn as hasDownstreamApiAuthorizationError,
  xn as hasDownstreamApiBadRequestError,
  bn as hasDownstreamApiConflictError,
  wn as hasDownstreamApiForbiddenError,
  Cn as hasDownstreamApiNotFoundError,
  yn as hasDownstreamApiPermissionError,
  En as hasDownstreamApiServiceUnavailableError,
  _n as hasDownstreamApiTooManyRequestsError,
  jr as hasWidgetMisconfiguredError,
  _r as isDixaHeaderCheckError,
  Or as isDownstreamApiAuthorizationError,
  Dr as isDownstreamApiBadRequestError,
  Ar as isDownstreamApiConflictError,
  Nr as isDownstreamApiForbiddenError,
  Sr as isDownstreamApiNotFoundError,
  Tr as isDownstreamApiPermissionError,
  Rr as isDownstreamApiServiceUnavailableError,
  Ir as isDownstreamApiTooManyRequestsError,
  Ur as isRunningLocalPartnerApi,
  Pr as isWidgetMisconfiguredError,
  gn as makeExecuteQuery,
  fn as makeUseLazyQuery,
  pn as makeUseMutation,
  dn as makeUseQuery,
  $r as parseAccessToken,
  gr as updateWidgetConfigurationMutation,
  Mr as useCopyWithDelay,
  Wn as useData,
  Vr as useInboundOAuthContext,
  Be as useTracking,
  Ot as useWidgetContext,
  Fn as useWidgetSettingsMutations,
  An as validateApiHostName
};
